"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@angular/common/http");
var locale_service_1 = require("../service/locale-service");
var moment = require("moment");
var core_1 = require("@angular/core");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
require('moment-jdateformatparser');
/**
 * @author Tigran.Sargsyan on 27-Aug-18.
 */
var HttpLocaleService = /** @class */ (function (_super) {
    __extends(HttpLocaleService, _super);
    function HttpLocaleService(http, applicationPropertiesService) {
        var _this = _super.call(this) || this;
        _this.http = http;
        _this.applicationPropertiesService = applicationPropertiesService;
        _this.localeCache = new Map();
        _this.localeServiceUri = _this.applicationPropertiesService.getProperty(HttpLocaleService_1.SERVICE_NAME);
        return _this;
    }
    HttpLocaleService_1 = HttpLocaleService;
    HttpLocaleService.prototype.formatDate = function (utcTime, languageID) {
        var _this = this;
        if (HttpLocaleService_1.isEmpty(utcTime)) {
            return Promise.resolve('');
        }
        return this.getLocaleInfo(languageID).then(function (localeInfo) {
            return _this.formatDateByLocale(utcTime, localeInfo);
        });
    };
    HttpLocaleService.prototype.formatDateByLocale = function (utcTime, localeInfo) {
        var date = moment(utcTime);
        HttpLocaleService_1.addTimeZoneOffset(localeInfo.timeZoneOffset, date);
        date.locale(HttpLocaleService_1.getLocale(localeInfo.locale, localeInfo.country));
        return date.formatWithJDF(localeInfo.datePattern);
    };
    HttpLocaleService.prototype.formatTime = function (utcTime, languageID) {
        var _this = this;
        if (HttpLocaleService_1.isEmpty(utcTime)) {
            return Promise.resolve('');
        }
        return this.getLocaleInfo(languageID).then(function (localeInfo) {
            return _this.formatTimeByLocale(utcTime, localeInfo);
        });
    };
    HttpLocaleService.prototype.formatTimeByLocale = function (utcTime, localeInfo) {
        var date = moment(utcTime);
        HttpLocaleService_1.addTimeZoneOffset(localeInfo.timeZoneOffset, date);
        date.locale(HttpLocaleService_1.getLocale(localeInfo.locale, localeInfo.country));
        return date.formatWithJDF(localeInfo.timePattern);
    };
    HttpLocaleService.prototype.formatDateTime = function (utcTime, languageID) {
        var _this = this;
        if (HttpLocaleService_1.isEmpty(utcTime)) {
            return Promise.resolve('');
        }
        return this.getLocaleInfo(languageID).then(function (localeInfo) {
            return _this.formatDateTimeByLocale(utcTime, localeInfo);
        });
    };
    HttpLocaleService.prototype.formatDateTimeByLocale = function (utcTime, localeInfo) {
        var date = moment(utcTime);
        HttpLocaleService_1.addTimeZoneOffset(localeInfo.timeZoneOffset, date);
        date.locale(HttpLocaleService_1.getLocale(localeInfo.locale, localeInfo.country));
        return date.formatWithJDF(localeInfo.datePattern + ' ' + localeInfo.timePattern);
    };
    HttpLocaleService.prototype.formatNumber = function (number, languageID) {
        var _this = this;
        if (HttpLocaleService_1.isEmpty(number)) {
            return Promise.resolve('');
        }
        return this.getLocaleInfo(languageID).then(function (localeInfo) {
            return _this.formatNumberByLocale(number, localeInfo);
        });
    };
    HttpLocaleService.prototype.formatNumberByLocale = function (number, localeInfo) {
        var numberFormat = localeInfo.numberFormat;
        return HttpLocaleService_1.format(number, numberFormat.groupSeparator, numberFormat.decimalSeparator, numberFormat.fractionDigits);
    };
    HttpLocaleService.prototype.getLocaleInfo = function (languageId) {
        var _this = this;
        if (HttpLocaleService_1.isEmpty(languageId)) {
            throw new TypeError("language id must be present, but was " + languageId);
        }
        var localeInfo = this.localeCache.get(languageId);
        if (!Boolean(localeInfo)) {
            localeInfo = new Promise(function (resolve) {
                _this.localeServiceUri.then(function (url) {
                    var localeInfo = _this.http.get(HttpLocaleService_1.LOCALE_PATH.replaceTemplate({
                        serviceUri: url,
                        languageId: languageId + ''
                    })).toPromise();
                    resolve(localeInfo);
                });
            });
            this.localeCache.set(languageId, localeInfo);
        }
        return localeInfo;
    };
    HttpLocaleService.isEmpty = function (utcTime) {
        return utcTime == null; // also  checks undefined
    };
    HttpLocaleService.addTimeZoneOffset = function (timeZoneOffset, date) {
        if (timeZoneOffset != null) {
            date.utcOffset(timeZoneOffset / 60);
        }
    };
    HttpLocaleService.getLocale = function (language, country) {
        return language + '-' + country;
    };
    /**
     * Format a number to produce a string.
     * @param number to format.
     * @param groupSeparator thousands separator character.
     * @param decimalSeparator decimal separator character.
     * @param fractionDigits number of digits after decimal fraction.
     */
    HttpLocaleService.format = function (number, groupSeparator, decimalSeparator, fractionDigits) {
        if (groupSeparator === void 0) { groupSeparator = ','; }
        if (decimalSeparator === void 0) { decimalSeparator = '.'; }
        var str = Boolean(fractionDigits) ? String(Number(number.toFixed(fractionDigits))) : String(number);
        var groupIndent = /\B(?=(\d{3})+(?!\d))/g;
        if (str.includes('.')) {
            var parts = str.split('.');
            return parts[0].replace(groupIndent, groupSeparator) + decimalSeparator + parts[1];
        }
        else {
            return str.replace(groupIndent, groupSeparator);
        }
    };
    HttpLocaleService.LOCALE_PATH = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", "/languages/", "/locale-info"], ["", "/languages/", "/locale-info"])), 'serviceUri', 'languageId');
    HttpLocaleService.SERVICE_NAME = 'ml-service-url';
    HttpLocaleService = HttpLocaleService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient, idm_application_properties_service_client_js_1.ApplicationPropertiesService])
    ], HttpLocaleService);
    return HttpLocaleService;
    var HttpLocaleService_1;
}(locale_service_1.LocaleService));
exports.HttpLocaleService = HttpLocaleService;
var templateObject_1;
//# sourceMappingURL=http-locale-service.js.map